// Environment configuration
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
export const config = {
  // API Configuration
  API_BASE_URL: isDevelopment ? 'http://localhost:8000' : 'https://api.coinvat.io',
  
  // App Configuration
  APP_NAME: 'CoinVAT',
  APP_VERSION: '1.0.0',
  
  // Feature Flags
  SHOW_UNDER_CONSTRUCTION: true, // Set to true to enable under construction banner
  
  // Storage Keys
  STORAGE_KEYS: {
    ACCESS_TOKEN: 'coinvat_access_token',
    REFRESH_TOKEN: 'coinvat_refresh_token',
    TOKEN_EXPIRES_AT: 'coinvat_token_expires_at',
    USER_PROFILE: 'coinvat_user_profile',
  },
  
  // Default redirect paths
  DEFAULT_LOGIN_REDIRECT: '/dashboard',
  DEFAULT_LOGOUT_REDIRECT: '/',
  
  // Token expiry buffer (refresh 1 minute before expiry)
  TOKEN_REFRESH_BUFFER: 60 * 1000, // 1 minute in milliseconds
} as const;

export default config;